// LEGACY
import VehiclePreview from './vehicle-preview';

export default VehiclePreview;
